export function isSsr40KG(ssrCode) {
  return ssrCode === 'XBAG' || ssrCode === 'EB40'
}